export const environment = {
  isProduction: false,
  builderPublicKey: 'd529abc1abab42478a97ddd45545ef57',
  digitalProductsBuilderKey: '4caa3a425c85496e9b99e391d030985f',
  contentAPIUrl: 'https://cdn.builder.io/api/v3/content/',
  enableLogging: true,
  baseUrl: 'https://gs-qa-east-oas-api.azurewebsites.net',
  authUrl: 'https://gs-qa-east-oas-auth-api.azurewebsites.net',
  blogBaseUrl: 'https://www.gassouth.com/blog',
  websiteBaseUrl: 'https://www.gassouth.com',
  appWebApiBaseUrl: 'https://gassouth-oas-qa-east-systemsapiv2.azurewebsites.net/',
  manageAccountUrl: 'https://manage.gassouth.com',
  deviceInfo: null,
  ClientId: 'GS-5E027899-FB73-47B2-8E23-AA0985EF4B82',
  Validate: 'Yes',
  MobileClientId: 'GSM-F5C64A24-A5D1-4293-8895-F4A94A864312',
  MobileApiKey: '',
  requestKeysAPP: {
    ApiKey: '',
    Validate: 'Yes',
    ClientId: 'OAS-051A648D-52DE-4AAA-AD32-60C860DEFDB4',
  },
  AuthToken: '',
  OASUrl() {
    return this.baseUrl + '/api';
  },
  paymentusTokenUrl() {
    return 'https://secure4.paymentus.com/api/v2/profiles/gass';
  },
  paymentusDigitalTokenUrl() {
    return 'https://secure4.paymentus.com/xotp/pm/GASS';
  },
  paymentusUrl() {
    return 'https://secure4.paymentus.com';
  },
  /** Path pattern used to detect digital payment callback URL in InAppBrowser */
  digitalPaymentCallbackPath: '/digital-payment-callback',
  AuthUrl() {
    return this.authUrl + '/api';
  },
  createCSRUrl() {
    return this.appWebApiBaseUrl + 'oas/api';
  },
  NotificationsUrl(local = false) {
    return local ? 'https://localhost:44369/api' : this.appWebApiBaseUrl + 'communication/api';
  },
  appInsightsConnectionString:
    'InstrumentationKey=c0037544-272a-4b95-9d0f-5e6e2fa1b5f6;IngestionEndpoint=https://eastus-4.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=1b339f03-9b49-4bc7-a7fe-762d48f63cf3',
  navMargin: false,
  mobileNavMargin: false,
  chatBotURL: 'https://gassouth-chat-service.us.cloud.uniphorestaging.com/create-client',
  enableChatbot: true,
  customerCookie: false,
  paymentusEncryptionKey: '',
};
